var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scholar-search" }, [
    _c("div", { staticClass: "content", staticStyle: { flex: "1" } }, [
      _vm.$route.name === "scholarSearchGuoJiao"
        ? _c("div", { staticClass: "infor" }, [
            _c("h1", { staticClass: "title" }, [
              _c("img", {
                attrs: {
                  width: "184",
                  height: "44",
                  src: require("@/assets/images/talent/talent-search-title.png"),
                  alt: "",
                },
              }),
            ]),
            _c("p", { staticClass: "tips" }, [
              _vm._v("用于分析某位学者画像及成果发表情况"),
            ]),
            _c(
              "div",
              { staticClass: "search-box" },
              [
                _c("textareaComp", {
                  ref: "textAreaRef",
                  staticStyle: { margin: "0 auto" },
                  attrs: { "text-area-width": `900px`, "rows-number": 3 },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "recommends-list" },
              _vm._l(_vm.recommendData, function (item, index) {
                return _c(
                  "p",
                  {
                    key: index,
                    staticClass: "item",
                    on: {
                      click: function ($event) {
                        return _vm.handleClickRecommend(item)
                      },
                    },
                  },
                  [
                    item.type === "1"
                      ? _c("img", {
                          attrs: {
                            width: "17",
                            height: "15",
                            src: require("@/assets/images/talent/talent-search-icon.png"),
                            alt: "",
                          },
                        })
                      : _vm._e(),
                    _c("span", [_vm._v(_vm._s(item.question))]),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "recommends-scholar",
              },
              [
                _c("h3", [_vm._v("为您推荐")]),
                _c("SearchScholarList", {
                  ref: "SearchScholarList",
                  attrs: {
                    "person-list": _vm.talentData,
                    "city-type": _vm.talentLocationValue,
                  },
                }),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "history-list" }, [_c("historyChat")], 1),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }